import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { isDebug } from "../../../../../utils";
import _ from 'lodash';


export const TastePotentialGraph = ({
  acidityPotential = 0,
  sweetnessPotential = 0,
  aromaPotential = 0,
  bodyPotential = 0,
  bitternessPotential = 0,
}) => {
  if (isDebug()) console.log(
    "Props in AromaPotentialGraph:",
    acidityPotential,
    sweetnessPotential,
    aromaPotential,
    bodyPotential,
    bitternessPotential,
  );
  const chartRef = useRef(null);
  const myChart = useRef(null);
  const MAX = 1;
  const textColor = "#333";

  useEffect(() => {
    if (chartRef.current) {
      myChart.current = echarts.init(chartRef.current);
    }

    const option = {
      title: {
        text: '{icon|} Taste Potential',
        textStyle: {
          color: "#121312",
          rich: {
            icon: {
              height: 20,
              width: 20,
              align: "left",
              backgroundColor: {
                image: 'data:image/png;base64,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',
              }
            },
          },
        },
      },

      radar: {
        splitNumber: 5,
        radius: Math.round(myChart.current._dom.offsetWidth) < 400 ? "55%" : "68%",
        indicator: [
          {
            name: "Acidity\npotential",
            max: MAX,
            nameLocation: "end",
            axisLabel: {
              show: true,
            },
            nameTextStyle: { color: textColor },
          },
          {
            name: "Sweetness\npotential",

            max: MAX,
            nameTextStyle: { color: textColor },
          },
          {
            name: "Aroma\npotential",
            max: MAX,
            nameTextStyle: { color: textColor },
          },
          {
            name: "Body\npotential",
            max: MAX,
            nameTextStyle: { color: textColor },
          },
          {
            name: "Bitterness\npotential",
            max: MAX,
            nameTextStyle: { color: textColor },
          },
        ],
        splitArea: {
          show: true,
          areaStyle: {
            color: ["rgba(255, 255, 255, 0)"],
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#ddd",
            width: 1,
            type: "solid",
          },
        },
        axisLabel: {
          color: "#333",
          fontSize: "11",
          verticalAlign: "top",
          align: "right",
        },
      },

      series: [
        {
          name: "Budget vs spending",
          type: "radar",
          symbol: "none",
          data: [
            {
              value: [
                acidityPotential,
                sweetnessPotential,
                aromaPotential,
                bodyPotential,
                bitternessPotential,
              ],
              name: "Allocated Budget",
              lineStyle: {
                type: [1, 2, 8, 2],
                color: "#215b38",
              },
              areaStyle: {
                color: "rgba(33, 91, 56, 0.5)",
              },
            },
          ],
        },
      ],
    };

    if (myChart.current) {
      myChart.current.setOption(option);
    }
            
            
    // 창크기 변경할때 카트를 갱신한다.
    const handleResize = _.debounce(() => {
        myChart.current?.resize();
    }, 50); // Debounce for 50ms

    window.addEventListener('resize', handleResize);

    return () => {
        try {
            window.removeEventListener('resize', handleResize);
        
            myChart.current && myChart.current.dispose();
            myChart.current && myChart.current.dispose();
            myChart.current = null;
        }
        catch (err) {
            console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
        }
    };
  }, [
    acidityPotential,
    sweetnessPotential,
    aromaPotential,
    bodyPotential,
    bitternessPotential,
  ]);

  return <div ref={chartRef} style={{ height: "400px", width: "100%" }} />;
};
